/**
 * axios二次封装
 */
import axios from 'axios'
import { showToast } from 'vant'
import router from '../router'
// 创建axios实例对象 添加全局配置
// const instance = axios.create({
//   baseURL: '',
//   headers: {}
// })
// 请求拦截
axios.interceptors.request.use((req) => {
  // console.log('请求拦截', req)
  req.headers.token = localStorage.tokenQa20240822
  return req
})
const agent = navigator.userAgent.toLowerCase()
const isMobilePhone = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(agent)
// 响应拦截
axios.interceptors.response.use((res) => {
  // console.log('1111', res)
  const { code, data, msg } = res.data
  if (code === 200) {
    return data
  } else if (code === 1) {
    localStorage.loginTypeQa20240822 = ''
    localStorage.tokenQa20240822 = ''
    showToast({
      message: msg,
      forbidClick: true
    })
    setTimeout(() => {
      if (isMobilePhone === true) {
        router.push({ name: 'Login' })
      } else {
        router.push({ name: 'LoginPc' })
      }
    }, 1000)
    return Promise.reject(msg)
  } else if (code === 101) {
    return Promise.reject(msg)
  } else if (code === 100) {
    return Promise.reject(msg)
  } else {
    showToast({
      message: msg,
      forbidClick: true
    })
    return Promise.reject(msg)
  }
})
// 封装 GET POST 请求并导出
function request (url = '', params = {}, type = 'POST') {
  // 设置 url params type 的默认值
  return new Promise((resolve, reject) => {
    let promise
    if (type.toUpperCase() === 'GET') {
      promise = axios({
        url: url,
        params
      })
    } else if (type.toUpperCase() === 'POST') {
      promise = axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json' // application/x-www-form-urlencoded
        },
        url: url,
        data: params
      })
    }
    // 处理返回
    promise.then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export default request
